import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const waiverTemplateMutations: UpdatesConfig['Mutation'] = {
  waiverTemplateCreate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery('waiverTemplates', cache);
  },
  waiverTemplateUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(['waiverTemplates', 'waiverTemplate'], cache);
  },
  waiverTemplateStatusUpdate: (_: Data, __: Variables, cache: Cache) => {
    // Draft forms are edited against the template's latest published version
    // (`currentTemplate`), so publishing a template mints a new version that
    // those drafts must pick up. Invalidate the form queries as well so a draft
    // reloads against the freshly published template instead of a stale one.
    invalidateQuery(['waiverTemplates', 'waiverTemplate', 'waiverForms', 'waiverForm'], cache);
  },
};

export default waiverTemplateMutations;
